var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,7.505c.552,0,1-.448,1-1V2c0-.552-.448-1-1-1s-1,.448-1,1V6.505c0,.552,.448,1,1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875,2.396c-.523-.168-1.09,.117-1.26,.643-.171,.525,.117,1.089,.643,1.26,2.061,.668,4.425,2.191,4.425,8.078,0,7.157-3.471,8.624-8.683,8.624S3.317,19.533,3.317,12.376c0-5.87,2.366-7.397,4.427-8.072,.525-.171,.811-.736,.639-1.261-.171-.525-.738-.814-1.261-.639C3.216,3.682,1.317,6.944,1.317,12.376c0,9.417,5.709,10.624,10.683,10.624s10.683-1.208,10.683-10.624c0-5.447-1.899-8.712-5.808-9.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.25ed18d98266eb35f7c5457957321fb1.svg";
export { ForwardRef as ReactComponent };